import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/utils/services/auth.service';
import { ParametrosService } from 'src/app/shared/utils/services/parametros.service';

@Injectable({
  providedIn: 'root'
})
export class GuardsService implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService,
    private parametrosService: ParametrosService
    ) { }

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const params = this.parametrosService.getSistema();
    if (params.isDesabilitarLogin) {
      return true;
    } else {
      if (this.authService.getAuthUser()) {
        return true;
      } else {
        this.router.navigate([params.rotaInicial]);
        return false;
      }
    }
  }
}
